import React, { useState } from "react";
import "../../styles/Dday.css";
import MainHeader from "../main/MainHeader";
import Footer from "../main/Footer";
import conv from "../../assets/lang/i18n";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import english from "date-fns/locale/en-US";
import korean from "date-fns/locale/ko";
import { Form } from "react-bootstrap";
import { Page2Meta } from "../../assets/meta/MetaTag";

const DdayPage = () => {
  const [Currentlang, setCurrentlang] = useState(conv.language); //브라우저 언어감지
  const onLanguageChange = (e) => {
    if (e.target.text === "English" || e.target.text === "영어") {
      conv.changeLanguage("en");
      setCurrentlang("en");
    } else {
      conv.changeLanguage("ko");
      setCurrentlang("ko");
    }
    return Currentlang;
  };
  const [BaseDate, setBaseDate] = useState(new Date());
  const [RstDate, setRstDate] = useState(new Date());

  const calcDays = (e) => {
    const year = BaseDate.getFullYear();
    const month = BaseDate.getMonth();
    const day = BaseDate.getDate();
    const addVal = e.target.value.replace(/[^0-9.]/g, "") * 1;
    const newDay = new Date(year, month, day + addVal);

    setRstDate(newDay);
  };

  return (
    <div>
      {Page2Meta()}
      <MainHeader paramChangeLanguage={onLanguageChange} />
      <div className="container py-5">
        <main>
          <div className="row row-cols-1 row-cols-md-3 mb-3 text-center">
            <div className="col">
              <div className="card mb-4 rounded-3 shadow-sm">
                <div className="card-header py-3">
                  <h4 className="my-0 fw-normal">{conv.t("dday.step1")}</h4>
                </div>
                <div className="card-body">
                  <h1 className="card-title pricing-card-title">
                    {conv.t("dday.step1_title")}
                  </h1>
                  <ul className="list-unstyled mt-3 mb-4">
                    <li>{conv.t("dday.step1_desc1")}</li>
                    <li>&nbsp;</li>
                    <li>{conv.t("dday.step1_desc2")}</li>
                    <li>{conv.t("dday.step1_desc3")}</li>
                  </ul>
                  <ReactDatePicker
                    className="w-100 btn btn-lg btn-outline-secondary"
                    locale={Currentlang === "ko" ? korean : english}
                    dateFormat="yyyy.MM.dd (eee)"
                    customInput={
                      <Form.Control
                        as="textarea"
                        rows={1}
                        style={{ width: "150px" }}
                      />
                    }
                    selected={BaseDate}
                    onChange={(date) => setBaseDate(date)}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card mb-4 rounded-3 shadow-sm">
                <div className="card-header py-3">
                  <h4 className="my-0 fw-normal">{conv.t("dday.step2")}</h4>
                </div>
                <div className="card-body">
                  <h1 className="card-title pricing-card-title">
                    {conv.t("dday.step2_title")}
                  </h1>
                  <ul className="list-unstyled mt-3 mb-4">
                    <li>{conv.t("dday.step2_desc1")}</li>
                    <li>{conv.t("dday.step2_desc2")}</li>
                    <li>{conv.t("dday.step2_desc3")}</li>
                    <li>{conv.t("dday.step2_desc4")}</li>
                  </ul>
                  <input
                    type="text"
                    className="w-100 btn btn-lg btn-primary"
                    id="num_duration"
                    placeholder={conv.t("dday.step2_placeholder")}
                    onChange={calcDays}
                    maxLength={6}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card mb-4 rounded-3 shadow-sm border-secondary">
                <div className="card-header py-3 text-white bg-secondary border-secondary">
                  <h4 className="my-0 fw-normal">{conv.t("dday.step3")}</h4>
                </div>
                <div className="card-body">
                  <h1 className="card-title pricing-card-title">
                    {conv.t("dday.step3_title")}
                  </h1>
                  <ul className="list-unstyled mt-3 mb-4">
                    <li>{conv.t("dday.step3_desc1")}</li>
                    <li>{conv.t("dday.step3_desc2")}</li>
                    <li>&nbsp;</li>
                    <li>{conv.t("dday.step3_desc3")}</li>
                  </ul>
                  <ReactDatePicker
                    className="w-100 btn btn-lg btn-outline-secondary"
                    locale={Currentlang === "ko" ? korean : english}
                    dateFormat="yyyy.MM.dd (eee)"
                    customInput={
                      <Form.Control
                        as="textarea"
                        rows={1}
                        style={{ width: "150px" }}
                      />
                    }
                    selected={RstDate}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default DdayPage;
